<template>
  <div>
    <div class="card p-2">
      <div>
        <h3 class="mb-0">
          แก้ไขแบนเนอร์
        </h3>
      </div>

      <div class="row mt-1">
        <div class="col-md-6">
          <validation-observer v-if="data" ref="simpleRules">
            <b-form>
              <b-row>
                <b-col md="12">
                  <b-form-group label="หัวข้อ (ไม่บังคับ)">
                    <b-form-input
                      v-model="data.title"
                      placeholder="เช่น โปรโมชั่นพิเศษ"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group>
                    <label>ลิ้งรูป <span class="text-danger">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      name="ลิ้งรูป"
                      rules="required"
                    >
                      <b-form-input
                        v-model="data.img_url"
                        :state="errors.length > 0 ? false : null"
                        placeholder="https://..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <img
                    v-if="data.img_url"
                    :src="data.img_url"
                    class="img-fluid rounded border"
                    style="max-width: 100%; max-height: 200px; object-fit: contain"
                    @error="imgError = true"
                  >
                  <small v-if="imgError" class="text-danger">โหลดรูปไม่ได้ กรุณาตรวจสอบ URL</small>
                </b-col>

                <b-col md="12">
                  <b-form-group label="ลิงก์เมื่อคลิก (ไม่บังคับ)">
                    <b-form-input
                      v-model="data.link_url"
                      placeholder="https://..."
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="ลำดับการแสดง (ตัวเลขน้อยแสดงก่อน)">
                    <b-form-input
                      v-model.number="data.order"
                      type="number"
                      min="0"
                      placeholder="0"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
          <div v-else class="text-center py-4">
            <b-spinner />
            <p class="mt-2">กำลังโหลด...</p>
          </div>
        </div>
      </div>

      <div v-if="data" class="col-md-12 mt-2">
        <b-button
          variant="primary"
          class="mr-1"
          @click.prevent="validationForm"
        >
          บันทึกข้อมูล
        </b-button>
        <b-button
          variant="outline-secondary"
          :to="{ name: 'banner' }"
        >
          ยกเลิก
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'EditBanner',
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  data() {
    return {
      required,
      data: null,
      imgError: false,
    }
  },
  mounted() {
    this.GetDetail()
  },
  watch: {
    'data.img_url'() {
      this.imgError = false
    },
  },
  methods: {
    async GetDetail() {
      await this.$http
        .get(`/banner/GetDetail/${this.$route.params.id}`)
        .then(response => {
          this.data = response.data
        })
        .catch(() => {
          this.SwalError('โหลดข้อมูลไม่สำเร็จ')
          this.$router.push('/Banner')
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$http
            .post(`/banner/update/${this.$route.params.id}`, this.data)
            .then(() => {
              this.Success('แก้ไขข้อมูลสำเร็จ')
              this.$router.push('/Banner')
            })
            .catch(() => {
              this.SwalError('แก้ไขข้อมูลไม่สำเร็จ')
            })
        }
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>
